import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/hooks/useAuth';
import { TreeDeciduous, FileText, Image, MapPin } from 'lucide-react';

export function Home() {
  const { t } = useTranslation();
  const { isAuthenticated } = useAuth();

  const features = [
    {
      icon: TreeDeciduous,
      title: 'Stammbaum-Visualisierung',
      description: 'Interaktive, ansprechende Darstellung deiner Verwandtschaftsbeziehungen',
    },
    {
      icon: FileText,
      title: 'Dokumenten-Management',
      description: 'Upload und Verwaltung aller Quelldokumente an einem Ort',
    },
    {
      icon: Image,
      title: 'Foto-Galerie',
      description: 'Historische Familienfotos mit Personen-Tagging',
    },
    {
      icon: MapPin,
      title: 'Orts-Verknüpfung',
      description: 'Geografische Zuordnung von Adressen und Orten',
    },
  ];

  return (
    <div className="flex flex-col">
      {/* Hero Section */}
      <section className="container flex flex-col items-center justify-center gap-4 py-24 text-center">
        <h1 className="text-4xl font-bold tracking-tight sm:text-5xl md:text-6xl lg:text-7xl">
          <span className="text-primary">Antree</span>
        </h1>
        <p className="max-w-[42rem] text-xl sm:text-2xl">
          {t('app.tagline')}
        </p>
        <div className="flex gap-4 mt-6">
          {isAuthenticated ? (
            <Link to="/dashboard">
              <Button size="lg">{t('nav.dashboard')}</Button>
            </Link>
          ) : (
            <>
              <Link to="/register">
                <Button size="lg">{t('auth:register.submit', { ns: 'auth' })}</Button>
              </Link>
              <Link to="/login">
                <Button variant="outline" size="lg">
                  {t('auth:login.title', { ns: 'auth' })}
                </Button>
              </Link>
            </>
          )}
        </div>
      </section>

      {/* Features Section */}
      <section className="container py-12 md:py-24">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
          {features.map((feature, index) => (
            <div
              key={index}
              className="flex flex-col items-center text-center p-6 rounded-lg border bg-card"
            >
              <feature.icon className="h-12 w-12 text-primary mb-4" />
              <h3 className="font-semibold text-lg mb-2">{feature.title}</h3>
              <p className="text-sm">{feature.description}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
